export default __webpack_public_path__ + "static/media/slide26.7527e308.jpg";